export const LinkIfHref: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement>
> = ({ href, children, ...rest }) =>
  href ? (
    <a href={href} {...rest}>
      {children}
    </a>
  ) : (
    <>{children}</>
  );
